<template>
    <v-app id="app">
      <v-dialog
        v-model="logoutDialog"
        fullscreen
        transition="dialog-bottom-transition">
        <v-card class="d-flex align-center text-center" style="background: rgba(255, 255, 255, 0.96)">
          <div style="width: 100%">
            <div class="my-3 d-block">
              <div class="text-left pb-3" style="width: 60%; margin:0 auto">
                <h3 class="mb-3">Your session is about to end.</h3>
                You've been inactive for a while. For your security, we'll automatically sign you out in 1 minute. You may choose "Stay signed in" to continue or sign out if you're done.
              </div>
            </div>
            <v-progress-linear
              v-model="progressValue"
              color="primary"
              height="80"
              class="mb-6">
          </v-progress-linear>
            <v-btn
              text
              outlined
              class="my-3 mr-3"
              color="primary"
              @click="logOut()">
              Sign Out
            </v-btn>
            <v-btn
              class="my-3 ml-3"
              color="primary"
              @click="stopProgress()">
              Stay signed in
            </v-btn>
          </div>
        </v-card>
      </v-dialog>

      <v-main v-if="!isMobile()" :class="mainClasses">
        <keep-alive
          :include="['Benchmarking']"
        >
          <router-view @authenticated="setAuthenticated()"></router-view>
        </keep-alive>
      </v-main>
      <v-main v-if="isMobile()">
        <MobileLanding />
      </v-main>
      <Footer />
    </v-app>
</template>

<script>
	import Cookie from 'js-cookie';
	import fonts from './assets/css/fonts.css';

	import Footer from './components/Footer';
	import MobileLanding from './components/MobileLanding';

	export default {
    	name: 'App',

    	components: {
        	Footer,
        	MobileLanding
    	},
	
		data() {
			return {
				authenticated: false,
				inactivityTime: 60 * 60 * 1000, // 15 minutes in milliseconds = 15 * 60 * 1000
				logoutTimer: false,
				logoutDialog: false,
				progressValue: 0, // initial progress value
				duration: 60, // duration in seconds
				timer: null,
				interval: 100, // interval for updating progress (milliseconds)
				stopped: false, // flag to indicate if the process was stopped
			}
		},

		watch: {
			authenticated: function(bool) {
				if ( bool ) {
					document.addEventListener("mousemove", () => {
						if ( Cookie.get('token') ) {
							this.resetTimer()
						}
					})
				
					document.addEventListener("keypress", () => {
						if ( Cookie.get('token') ) {
							this.resetTimer()
						}
					})

					// Start the timer when the page loads
					this.resetTimer()
				}
			}
		},

		computed: {
			mainClasses () {
				const isPdfPage = ['ListingDetailAsPdf'].includes(this.$route.name)

				return [
					'content',
					isPdfPage ? 'content-is-pdf' : '',
				]
			},
		},

		mounted () {
			this.setAuthenticated();
		},

		beforeDestroy() {
			clearInterval(this.timer); // Clear the timer on component destroy
		},

		methods: {
			setAuthenticated() {
        if ( !['newuser', 'survey'].includes(this.$router.history.current.name) ) {
          this.authenticated = Cookie.get('token') ? true : false;
              
          if ( !this.authenticated ) {
            this.$router.replace({ name: 'login' }).catch(err => {});
          }
        }
			},
		
			logOut: function () {
				Cookie.remove('token')
				Cookie.remove('is_client')
				Cookie.remove('has_profile')
				Cookie.remove('name')
				Cookie.remove('id')
				Cookie.remove('sugar')

				this.logoutDialog = false
				this.authenticated = false
			
				clearInterval(this.timer)
				clearTimeout(this.logoutTimer)
				this.timer = null
				this.progressValue = 0
				this.stopped = false

				this.$router.replace({ name: 'login' }).catch(err => {})
			},

			logoutWarn: function () {
				// this.logoutDialog = true
				// this.startProgress()
				this.logOut()
			},

			resetTimer: function () {
				clearTimeout(this.logoutTimer);
				this.logoutTimer = setTimeout(this.logoutWarn, this.inactivityTime);
			},

			startProgress: function () {
				const steps = Math.ceil((this.duration * 1000) / this.interval);
				let count = 0;

				this.timer = setInterval(() => {
					if (!this.stopped) {
						count++;
						this.progressValue = (count / steps) * 100;

						if (this.progressValue >= 100) {
							clearInterval(this.timer);
							setTimeout ( () => {
								this.logOut()
							}, 200)
						}
					}
				}, this.interval);
			},

			stopProgress: function () {
				clearInterval(this.timer)
				clearTimeout(this.logoutTimer)
				this.stopped = true
				this.timer = null
				this.progressValue = 0
				this.logoutDialog = false
				this.resetTimer()
				this.stopped = false
			},

			isMobile: function() {
				var check = false;
				(function(a){
					if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
						return check;
			}
		}
	}
  
</script>

<style>
  html {
    overflow-y: auto !important;
  }
  body {
    height: 100vh;
    width: 100vw;
  }

  #app {
    background-color: #EFEFEF;
    font-family: 'AvenirBook', Arial, Helvetica, sans-serif;
  }
  .sansation {
    font-family: 'Sansation';
    font-size: 1rem !important;
  }
  .sansation_light {
    font-family: 'SansationLight';
    font-size: .9rem !important;
  }
  .sansation_title {
    font-family: 'Sansation';
    font-size: 1.3rem !important;
    font-weight: bold;
  }
  .sansation_subtitle {
    font-family: 'Sansation';
    font-size: 1.3rem !important;
  }
  .sansation_headline {
    font-family: 'Sansation';
    font-size: 1.5rem !important;
    font-weight: bold;
  }
  .sansation_super {
    font-family: 'SansationLight';
    font-size: 1.6rem !important;
    line-height: 1.8rem;
  }
  .avenir_book {
    font-family: 'AvenirBook';
  }
  .avenir_medium {
    font-family: 'AvenirMedium';
  }
  .avenir_black {
    font-family: 'AvenirBlack';
  }
  .feedback_smaller {
    font-size: .975rem;
  }
  .pg_title_color, .pg_subtitle_color {
    color: #5F6062;
  }
  .content {
    padding: 0;
    margin: 0 auto;
  }

  .content.content-is-pdf {
    margin: 0;
  }

  .v-application .container_width {
    max-width: 100%;
    width: 1280px;
  }

  /* .content_width {
    width: 1280px;
    margin: 0 auto;
  } */

  .v-application .user_menu {
    font-family: 'Sansation';
    color: #37383C;
    text-decoration-line: none;
    cursor: pointer;
  }
  .v-application .user_menu:hover {
    font-family: 'Sansation';
    text-decoration-line: none;
    background-color: #F4FBFC;
    cursor: pointer;
  }

  .v-application .button_link {
    font-family: 'Sansation';
    color: #37383C;
    text-decoration-line: none;
  }
  .v-application .button_link:hover {
    font-family: 'Sansation';
    color: #0096A6;
    text-decoration-line: none;
  }
  .v-application .button_link:active {
    font-family: 'Sansation';
    color: #0096A6;
    text-decoration-line: none;
    font-weight: 800;
  }

  .v-application a.header_links {
    font-family: 'Sansation';
    color: #EFEFEF;
    text-decoration-line: none
  }
  .v-application a.header_links:hover {
    font-family: 'Sansation';
    color: #FFFFFF;
    text-decoration-line: none;
  }
  .v-application a.header_links:active {
    font-family: 'Sansation';
    color: #EFEFEF;
    text-decoration-line: none;
    font-weight: 800;
  }

  .logo_style {
    /* width: 176px; */
    height: 52px;
  }

  .button_text {
    font-family: 'Sansation';
    font-size:1.25em;
  }
  .menu_border {
    border-bottom: 1px solid #BBB
  }
  .text_condensed {
    letter-spacing: 0rem;
  }
  .footer_black {
    color: #37383C;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue